// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"work","211":"works","594":"about"}[chunkId] + "." + {"112":"aaf5549c","211":"471fe4c4","594":"5d54545e"}[chunkId] + ".js";
};